import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { getUser } from '../utils/helpers/userHelper';
import { getAccessToken } from '../utils/helpers/tokenHelper';

export const AuthRoute = ({ component: Component, extraProps, ...rest }) => (
  <Route {...rest} render={props => {
    if (getUser() && getAccessToken()) {
      return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
    }

    return <Component {...props} />;
  }} />
);
